import { render } from "./RichListItem.vue?vue&type=template&id=66128883&scoped=true"
import script from "./RichListItem.vue?vue&type=script&lang=js"
export * from "./RichListItem.vue?vue&type=script&lang=js"

import "./RichListItem.vue?vue&type=style&index=0&id=66128883&lang=sass&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66128883"]])

export default __exports__